// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_2aM77","message":"_2QfX4","stack":"_1-LTw","stackContent":"_3zzKn"};